import { call, put, takeEvery } from "redux-saga/effects";
import {
  INITIALIZE_PAY_DATA,
  GET_INSTALLMENTS,
} from "./actionTypes"

import {
  initializePayDataSuccess,
  getInstallmentsSuccess,
  installmentApiError
} from "./actions"

//Include Both Helper File with needed methods
import {
  getInstalments,
} from "../../helpers/backend_helper/backend_helper"

import { isInstallmentErrorResponse, toPlainApiError } from "helpers/apiErrorHelper"

function* onGetInstalments({ payload: record }) {
  try {
    const response = yield call(getInstalments, record)
    if (isInstallmentErrorResponse(response)) {
      yield put(installmentApiError(toPlainApiError(response)))
      return
    }
    yield put(getInstallmentsSuccess(response))
  } catch (error) {
    yield put(installmentApiError(toPlainApiError(error)))
  }
}

function* onInitializePayData({ payload: { record, value, name } }) {
  try {
    record = record === undefined ? {} : record
    if (name === "installmentCount") {
      record.installmentCount = value;
    }
    if (name === "merchantInfo") {
      record.merchantInfo = { nameSurname: value.nameSurname, phoneNumber: value.phoneNumber, email: value.email, address: value.address }
    }
    if (name === "cardHolder") {
      record.cardHolder = value;
    }
    if (name === "cardNumber") {
      record.cardNumber = value;
    }
    if (name === "expireDate") {
      record.expireDate = value;
    }
    if (name === "threeDPay") {
      record.saleIs3d = value;
    }
    if (name === "cvv") {
      record.cvv = value;
    }
    if (name === "linkKey") {
      record.linkKey = value;
    }
    if (name === "installmentAmount") {
      record.amount = value;
    }
    if (name === "paymentPageTransaction") {
      record.saleIs3d = true;
      record.paymentPageTransaction = {
        paymentMethodDefGuid: value.paymentMethodDefGuid,
        uniqueId: value.uniqueId,
        merchantId: value.merchantId,
        merchantGuid: value.merchantGuid,
        returnUrl: value.returnUrl,
        failUrl: value.failUrl,
        paymentMethod: value.paymentMethod,
        paymentInstrumentType: value.paymentInstrumentType,
        language: value.language,
        conversationId: value.conversationId,
        transactionType: value.transactionType,
        installmentCount: record.installmentCount,
        amount: value.amount,
        currencyCode: value.currencyCode,
        pfSubMerchantId: value.pfSubMerchantId,
        orderId: value.orderId ?? "",
        act: value.act ?? "",
        guid: value.guid,
        status: value.status,
        currencyAlphaCode: value.currencyAlphaCode
      }
    }




    yield put(initializePayDataSuccess(record))
  } catch (error) {
    yield put(installmentApiError(error))
  }
}

function* installmentSaga() {
  yield takeEvery(GET_INSTALLMENTS, onGetInstalments)
  yield takeEvery(INITIALIZE_PAY_DATA, onInitializePayData)
}

export default installmentSaga